<div [hidden]="!active" class="tab">
  <ng-content></ng-content>
</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-tabs/achoo-tab/achoo-tab.component.html